/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	HubSpotLinkSearchPathParams,
	HubSpotLinkSearchQueryParams,
	HubSpotLinkSearchResponse,
} from '../types/HubSpotLinkSearch'

/**
 * GET /:organisation/hubspot/search
 * @see backend/nexus/modules/SupplyChain/Http/Controllers/HubSpotLinkController.php HubSpotLinkController::search
 */
export async function hubSpotLinkSearch(
	organisation: HubSpotLinkSearchPathParams['organisation'],
	params?: HubSpotLinkSearchQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<HubSpotLinkSearchResponse>> {
	return axiosInstance.get(`/${organisation}/hubspot/search`, { params, ...config })
}
